import { Component, EventEmitter, input, Input, OnInit, output, Output } from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { CheckIconComponent, ErrorIconComponent } from 'remarketing-ui-components-lib';
import { Subject } from 'rxjs';
import { Configuration, ConfigurationState } from 'remarketing-angular-library';
import { select, Store } from '@ngxs/store';

@Component({
  selector: 'app-action-list-message-modal',
  imports: [TranslocoDirective, CheckIconComponent, ErrorIconComponent],
  templateUrl: './action-list-message-modal.component.html',
  styleUrl: './action-list-message-modal.component.scss'
})
export class ActionListMessageModalComponent implements OnInit {

  public readonly messages$ = input<Map<string, string[]>>();

  public readonly close = output();
  public readonly error = output<string>();

  protected readonly configuration$ = select(ConfigurationState.configuration);

  protected successMessage = '';
  protected errorMessages: string[] = [];
  protected headerMessage = '';

  ngOnInit(): void {
    this.successMessage =
      this.messages$().get('success') && this.messages$().get('success').length > 0 ? this.messages$().get('success')[0] : '';
    this.errorMessages = this.messages$().get('error');
    this.headerMessage =
      this.messages$().get('header') && this.messages$().get('header').length > 0 ? this.messages$().get('header')[0] : '';
  }

  closeModal() {
    this.close.emit();
  }
}
